<template>
	<el-dialog :visible.sync="is_visible" :width="'40%'" @closed="close" :modal="false">
		<template slot="title">
			<div v-if="!is_attachment_only">
				<h3 class="mb-0 font-weight-500">{{ is_update ? 'Update Disbursement' : 'Add Disbursement' }}</h3>
				<span class="text-danger" v-if="is_update"><sub>*</sub> Edit disbursement will revise status to
					<strong>Pending</strong></span>
			</div>
			<div v-else>
				<h3 class="mb-0 font-weight-500">Attachments</h3>
			</div>
		</template>
		<b-form role="form">
			<b-row>
				<b-col cols="12" v-if="!is_attachment_only">
					<b-form-group label="Disbursement Amount (RM)">
						<b-input-group  :prepend="'RM'">
							<b-form-input
									v-model="form.amount"
									type="number"
									maxlength="15"
									:max="max_amount_allowed"
									placeholder="Disbursement Amount (RM)"
									step="0.01"
							>
							</b-form-input>
						</b-input-group>	
						<small class="text-info">Max Available To disburse RM {{ max_amount_allowed | moneyFormatter}}</small>
					</b-form-group>
				</b-col>
				<b-col cols="12" v-if="!is_attachment_only">
					<b-form-group label="Disbursement Date">
						<el-date-picker v-model="form.disburse_date" value-format="yyyy-MM-dd" type="date" placeholder="Pick a day">
						</el-date-picker>
					</b-form-group>
				</b-col>
				<b-col cols="12"  v-if="!is_attachment_only">
					<b-form-group label="Description">
						<b-form-textarea v-model="form.description" placeholder="Write remarks here" :readonly="form.description == 'Balance Disbursement'"></b-form-textarea>
					</b-form-group>
				</b-col>
				<b-col cols="12" v-if="!is_attachment_only">
					<b-form-group label="Bank Name">
						<el-select v-model="form.bank_id" placeholder="Select" @change="setBank($event)">
							<el-option :label="'No Selected'" :value="null"></el-option>
							<el-option v-for="(item,index) in allBanks" :key="index" :label="item.name"
								:value="item.bank_id">
							</el-option>
						</el-select>
					</b-form-group>
				</b-col>
				<b-col cols="12" v-if="form.bank_id == 31">
					<b-form-group label="Other Bank Name">
						<b-form-input v-model="form.bank_name" max="100" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col cols="12" v-if="!is_attachment_only">
					<b-form-group label="Bank Account No">
						<b-form-input v-model="form.bank_account" max="100" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group :label="!is_attachment_only ? 'Add Attachment (Optional)': null">
						<UploadFiles @addFiles="addFiles" />
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<div class="card-table-simple mb-5" v-loading="is_loading_attachment">
						<b-table-simple responsive class="mb-0">
							<b-thead>
								<b-tr>
									<b-th>Doc Name</b-th>
									<b-th v-if="is_update">Uploaded by</b-th>
									<b-th v-if="is_update">Date</b-th>
									<b-th></b-th>
								</b-tr>
							</b-thead>
							<b-tbody v-if="!_gHlp.isEmpty(currentAttachments) || !_gHlp.isEmpty(newAttachments)">
								<template v-if="is_update">
									<b-tr v-for="(data, index) in currentAttachments" :key="index">
										<b-td @click="$refs.preview_modal.preview(data.url, data.original_filename)"
											class="cursor-pointer text-primary font-weight-500">{{ data.filename }}</b-td>
										<b-td>{{ data.created_by_detail.name }}</b-td>
										<b-td>{{ data.created_at | dateFormatString }}</b-td>
										<b-td>
											<svg @click="deleteFile(data)" xmlns="http://www.w3.org/2000/svg"
												class="text-danger cursor-pointer" width="14" height="18" viewBox="0 0 448 512">
												<path fill="currentColor"
													d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zm96 64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16m96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16m96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16" />
											</svg>
										</b-td>
									</b-tr>
								</template>
								<b-tr v-for="(data, index) in newAttachments" :key="index">
									<b-td class="cursor-pointer text-primary font-weight-500">{{ data.upload.filename }}</b-td>
									<b-td v-if="is_update">-</b-td>
									<b-td v-if="is_update">-</b-td>
									<b-td>
										<svg @click="removeFile(data)" xmlns="http://www.w3.org/2000/svg" class="text-danger cursor-pointer"
											width="14" height="18" viewBox="0 0 448 512">
											<path fill="currentColor"
												d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zm96 64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16m96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16m96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16" />
										</svg>
									</b-td>
								</b-tr>
							</b-tbody>
							<b-tbody v-else>
								<b-tr>
									<b-td :colspan="is_update ? 4 : 2">No Attachment</b-td>
								</b-tr>
							</b-tbody>
						</b-table-simple>
					</div>
				</b-col>
				<b-col cols="12" class="text-center">
					<el-button class="bg-primary text-white w-100" @click.prevent="submit()" :loading="is_loading_btn">Save</el-button>
				</b-col>
			</b-row>
		</b-form>
		<PreviewModal ref="preview_modal"></PreviewModal>
	</el-dialog>
</template>
<script>
import { Button, DatePicker, Table, TableColumn, Dialog, Select, Option } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import UploadFiles from '@/views/Widgets/UploadFiles'

import { swal } from '@/assets/js/httpImports.js';
import { mapState, mapActions } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore';
import { useCommonStore } from '@/stores/commonStore';
import { useAttachmentStore } from '@/stores/attachmentStore';
import * as moment from 'moment';
import { apiDomain, services } from '@/assets/js/config.js';
import { applicationCode } from '@/assets/js/config.js';
import PreviewModal from '@/components/Modal/PreviewModal';

export default {
	components: {
		CurrencyInput,
		UploadFiles,
		PreviewModal,
		[Dialog.name]: Dialog,
		[Button.name]: Button,
		[Select.name]: Select,
		[Option.name]: Option,
		[DatePicker.name]: DatePicker,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn
	},
	data() {
		return {
			is_visible: false,
			is_update: false,
			is_loading_attachment: false,
			is_loading_btn: false,
			is_attachment_only: false,
			form: {
				disb_id: '',
				case_id: '',
				amount: '',
				bank_id: null,
				bank_name: '',
				bank_account: '',
				disburse_date: '',
				description: '',
				status: 'Pending',
			},
			max_amount_allowed: 0,
			newAttachments: [],
			currentAttachments: [],
			deleteAttachments: [],
		}
	},
	created() {
	},
	computed: {
		...mapState(useLoanCaseStore, ['activeCase','activeDisbursements']),
		...mapState(useCommonStore, ['allBanks']),
	},
	watch: {
		activeDisbursements: {
			handler(newVal) {
				this.setMaxAllowed(newVal)
			},
			immediate: true
		},
	},
	methods: {
		...mapActions(useLoanCaseStore, ['createDisb', 'updateDisb', 'getCase']),
		...mapActions(useAttachmentStore, ['getAttachmentList', 'detailAttachment', 'uploadAttachment', 'deleteAttachment']),
		show(editData=null, attachment_only=false){
			if (!_gHlp.isEmpty(editData)) {
				this.setForm(editData);
			}
			this.is_attachment_only = attachment_only;
			this.is_loading_btn = false
			this.is_visible = true
		},
		close() {
			this.clean();
			this.is_attachment_only = false
			this.is_loading_btn = false
			this.is_visible = false
		},
		clean() {
			this.form = {
				disb_id: '',
				case_id: '',
				amount: '',
				disburse_date: '',
				description: ''
			}
			this.newAttachments = [];
			this.currentAttachments = [];
			this.deleteAttachments = [];
			this.is_update = false
		},
		setForm(editData) {
			// this.clean();
			this.is_update = true;
			this.form = editData;
			this.getAttachments();
		},
		setMaxAllowed(list){
			this.max_amount_allowed = this.activeCase.loan_amount;
			if(!_gHlp.isEmpty(list)){
				const total_approved = list.reduce((tot, obj) => {
					return (obj.status == 'Approved') ? (tot + parseFloat(obj.amount)) : tot;
				}, 0)
				this.max_amount_allowed = parseFloat(this.activeCase.loan_amount) - parseFloat(total_approved)
			}
		},
		setBank(bank_id){
			const bank = this.allBanks.find(itm => itm.bank_id == bank_id);
			this.form.bank_name = _gHlp.getValue(bank,'name');
		},
		addFiles(items) {
			for (let i = 0; i < items.length; i++) {
				this.newAttachments.push(items[i]);
			}
		},
		removeFile(file) {
			this.newAttachments = this.newAttachments.filter(item => {
				return item.upload.uuid != file.upload.uuid;
			});
		},
		submit() {
			this.is_loading_btn = true;
			const params = {
				...this.form,
				total_attachment: this.currentAttachments.length + this.newAttachments.length,
				status: (this.is_attachment_only) ? this.form.status : 'Pending'
			};
			if (this.form.disb_id) {
				this.updateDisb(this.form.disb_id, params).then((resp) => {
					this.getCase();
					this.submitUploadAttachments();
					this.submitRemoveAttachments();
					this.$emit('closeModal', true);
					_gNotif.notifySuccess('<b>Disbursement</b> - Successfully Updated.')
					this.is_loading_btn = false;
					this.is_visible = false
				});
			} else {
				this.createDisb(params).then((resp) => {
					this.getCase();
					this.form.disb_id = resp.disb_id;
					this.form.case_id = resp.case_id;
					this.submitUploadAttachments();
					this.$emit('closeModal', true);
					_gNotif.notifySuccess('<b>Disbursement</b> - Successfully Created.')
					this.is_loading_btn = false;
					this.is_visible = false
				});
			}
		},
		submitRemoveAttachments() {
			if (_gHlp.isEmpty(this.deleteAttachments)) return false
			for (let i = 0; i < this.deleteAttachments.length; i++) {
				const itm = this.deleteAttachments[i];
				this.deleteAttachment(itm)
			}
		},
		submitUploadAttachments() {
			if (_gHlp.isEmpty(this.newAttachments)) return false
			let attachments = this.newAttachments;
			let owner_type = 'disbursement';
			let owner_id = this.form.disb_id;
			let tags = 'lms_' + this.form.case_id + '_case';

			for (let i = 0; i < this.newAttachments.length; i++) {
				const itm = this.newAttachments[i];
				let params = {
					folder: 'lms/' + owner_type + '/' + owner_id,
					owner_type: owner_type,
					owner_id: owner_id,
					// attachment_category_id: null,
					attachment_tags: tags,
					file: itm
				}
				this.uploadAttachment(params)
			}
		},
		getAttachments() {
			this.is_loading_attachment = true;
			this.getAttachmentList({ owner_id: this.form.disb_id, owner_type: 'disbursement' }).then(resp => {
				this.currentAttachments = resp.data;
				this.is_loading_attachment = false;
			}).catch(e => {
				_gNotif.errorFunction(e);
				this.is_loading_attachment = false;
			});
		},
		deleteFile(attachment) {
			swal.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, delete it!'
			}).then((result) => {
				if (result.isConfirmed) {
					if (_gHlp.isEmpty(this.currentAttachments)) return false
					this.currentAttachments = this.currentAttachments.filter(item => {
						return item.attachment_id != attachment.attachment_id;
					});
					this.deleteAttachments.push(attachment.attachment_id)
				}
			});
		}
	}
}
</script>